import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UniversalNoteService {
    private REST_API_SERVER = environment.apiUrl;

    constructor(private httpClient: HttpClient) { }

    private authOptions() {
        let headers = new HttpHeaders({
            Authorization: localStorage.getItem('bearerToken')
        });
        const impersonate = localStorage.getItem('impersonate');
        if (impersonate) {
            headers = headers.set('x-impersonate', impersonate);
        }
        return { headers };
    }

    public searchEntities(type: string, query: string) {
        return this.httpClient.post<any>(
            this.REST_API_SERVER + '/universalNote/searchEntities',
            { type, query },
            this.authOptions()
        );
    }

    public addNote(payload: any) {
        return this.httpClient.post<any>(
            this.REST_API_SERVER + '/universalNote/add',
            payload,
            this.authOptions()
        );
    }
}
